export const env = process.env.REACT_APP_ENV;
export const baseUrl = process.env.REACT_APP_BASE_URL;
export const loginUrl = process.env.REACT_APP_LOGIN_URL;
export const registrationUrl = process.env.REACT_APP_REGISTRATION_URL;
export const mixpanelApiKey = process.env.REACT_APP_MIX_PANEL_API_KEY;